import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { NotificationsService } from '../services/notifications.service';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {
  constructor(private readonly notificationsService: NotificationsService, private readonly authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        this.notificationsService.error(err.error.message);

        if (err.status === 401) {
          this.authService.logout();
        }

        throw err;
      })
    );
  }
}
